module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "chap-num"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('h2', {
    staticClass: "chap-title"
  }, [_vm._v("Nazis in Britain 1930–1939")]), _vm._v(" "), _c('div', {
    staticClass: "quotea"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Oh, what a tangled web we weave. When first we practise to deceive!")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Marmion, Sir Walter Scott")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("T")]), _vm._v("he dramatic rise of Oswald Mosley’s British Union of Fascists, his Blackshirt bullyboys and rabid anti-Semitism combine to leave a foul legacy that dominates many accounts of right-wing activities in Britain during the 1930s. But in the shadow of these events was a covert and sinister infiltration. The establishment of an overseas branch or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ostgruppe")]), _vm._v(" of the Nazi Party and Nazi intelligence gathering in the United Kingdom during the 1930s is far less known and its true extent has only been revealed by the release of secret files over the past twenty years. The Nazi Party gained its majority in the Reichstag in September 1930 and that same month, in an attempt to improve their international profile they sent Hans Wilhelm Thost to London to become their first full-time correspondent of the official Party newspaper, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Völkischer Beobachter")]), _vm._v(", in Britain, an action that also meant he became the first officially sponsored member of the Nazi Party in the country.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0001-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Reichsleiter")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Alfred Rosenberg giving an address in Berlin, 1934.")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thost would be given specific tasks or channels of inquiry to research by his superiors and he would send his reports back by post. Every three or four months he would return to Germany to meet with his superiors, notably his editor-in-chief, Alfred Rosenberg, the Nazi Party’s chief racial theorist. He was the proponent of the Nordic theory and notions of the ‘master race’ as well as being the architect of the anti-Jewish theories that the Nazis used to justify their racial and ethnic policies. At these meetings Thost would present a more detailed debrief, would answer questions and the next subjects to be researched would be discussed. Thost proved himself invaluable as one of the Nazi Party’s most direct sources for news of British social and political matters and the mood of the British people. He would be the first of many.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thost’s activities remained undetected by the British intelligence services for several months. The reasons for this are simple; in retrospect we have the advantage of being able to see that the machinations of the National-Sozialistische Deutsche Arbeiterpartei (NSDAP, commonly referred to as the Nazi Party in English) in Germany in 1930 was the first toe hold of the ascent to power of the Nazis. However, in the early 1930s the NSDAP was simply another political party in Germany that was far from securing enough votes to seize power. At the same time the manpower and resources of MI5 were limited.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the Nazis built on their successes in Germany, so they also sought to court the support of, and disseminate propaganda to, German nationals living and working abroad. They did so by establishing officially recognised Nazi Party groups or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ostgruppe")]), _vm._v(" in countries outside the Fatherland. Early in September 1931 Nazi party activist, 21-year-old Rolf Wunderer, was sent to London to muster members. His infectious fervour and enthusiasm talking to German nationals, particularly in the restaurants and tea houses of Soho, and his engagement with extant British Fascist groups enabled him to find numerous German nationals sympathetic to the Nazi cause.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The London "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ostgruppe")]), _vm._v(" held its first meeting at a Viennese restaurant in Soho in October 1931 with around twenty-eight members present. It was an evening where the hallmark Nazi ploy of blurring traditional German nationalism with Nazism was very much in evidence. As those present drank German beer and sang traditional German songs, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ostgruppe")]), _vm._v(" was "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("established and Thost was elected as leader or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ortsgruppenleiter")]), _vm._v(" and Wunderer as secretary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rosenberg was delighted to hear of Thost’s appointment and, to endorse the fledgling group and encourage its growth, he came to London for a week-long visit in November 1931. It was hardly headline news, indeed it was six days before any of the national newspapers picked up on his visit. Rosenberg gave interviews to a number of reporters claiming to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Manchester Guardian")]), _vm._v(" that his visit had ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("no political significance at all’")]), _vm._v(","), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Notes#rfnch01_1",
      "id": "fnch01_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" but in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daily Herald")]), _vm._v(" he was reported as saying: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("‘I came here to inform myself about the state of mind of Britain")]), _vm._v(" [but I have] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not seen any British public men and women of note.’")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Notes#rfnch01_2",
      "id": "fnch01_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Rosenberg had undoubtedly come to Britain to disseminate Hitler’s ideas to the new party faithful, but both newspapers and the Foreign Office were of the opinion he was also on a personal fact-finding mission to try and ascertain what the political and financial reaction in Britain would be if the Nazis came to power.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Horace Rumbold, the British Ambassador in Berlin, shared this opinion and in response to a Foreign Office enquiry into Rosenberg’s motives he also warned of darker undertones, describing the visit as being:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("… to prepare the way for his Chief")]), _vm._v(" [Hitler] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("who may very likely wish to visit England and, if possible, to make the acquaintance of leading British statesmen before the time, which may be soon, comes for his party to take an active part in controlling the destiny of Germany")]), _vm._v("."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Notes#rfnch01_3",
      "id": "fnch01_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Perhaps these were the first glimmers the British people had of Nazi German intentions involving Britain in their future plans for domination in Europe. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Führer")]), _vm._v(" himself held a strong personal belief that Britain would be won over to join with Nazi Germany by persuading those in power to embrace the Nazi way of thinking or, if the government remained obstinate in pursuing a war with Germany, he hoped the British people would rise up, dislodge the government and enter into a pact with Germany. Hitler’s feelings are summed up well in an incident recalled by General Franz Halder, chief of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oberkommando des Heeres")]), _vm._v(" staff and the senior German army planner of Operation Sealion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He entered the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Führer")]), _vm._v("’s office to find him reading a copy of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Illustrated London News")]), _vm._v("; as he looked up Hitler mused "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("‘That we have to make war against such personages, isn’t it a pity?’")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Notes#rfnch01_4",
      "id": "fnch01_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" As late as May 1940 Field Marshal Gerd von Rundstedt would recall a meeting with Hitler at Charleville where he expressed his admiration of the British Empire and his hopes for an earlier peace. General Günther Blumentritt, Operations Officer of Army Group A, wrote with regard to himself and his planning staff of how the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Führer")]), _vm._v(": "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("astonished us by speaking of his admiration for the British Empire, of the necessity for its existence and of the civilization that Britain had brought to the world.")]), _vm._v("’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Notes#rfnch01_5",
      "id": "fnch01_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first headquarters of the London "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ostgruppe")]), _vm._v(" was established in two rooms at 46, Cleveland Square, W2 in December 1931. Over the ensuing months the Nazi Party in London steadily increased its membership and began to hold political meetings behind closed doors in public buildings such as Porchester Hall, Bayswater. There had been rumblings of concern in the corridors of both the Home Office and the Foreign Office, but at the time the feeling was very much that as long as they didn’t break the law or attempt to subvert His Majesty’s Government they could be left alone by the authorities. In correspondence between the Foreign Office and the Home Office regarding "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Orstgruppenleiter")]), _vm._v(" Thost in 1932 it was pointed out:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("He would, of course, be breaking the law of England if he were to publish defamatory libels against the German Government which might affect friendly relations between that Government and His Majesty’s Government but there is no evidence he is doing this, and, as you know, prosecutions for this type of seditious libel are very rare and the authorities are always unwilling to launch them, as they may well do more harm than good")]), _vm._v("."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Notes#rfnch01_6",
      "id": "fnch01_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Nazi Party gained majority power in Germany early in 1933 and the London "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ostgruppe")]), _vm._v(" continued to grow. Meetings and social events were held regularly and membership rose to around 120 by April 1933. A new party headquarters was established at the Park Gate Hotel, Stanhope Terrace, near Lancaster Gate, Bayswater W2.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("April 1933 also saw concerns expressed in the House of Commons over the actions of the Nazi Party in Germany, especially its anti-Semitism and talk of expansion and ‘colonization schemes’ beyond Germany’s extant frontiers. The Nazi press was far from pleased by any suggestion of criticism of Nazi policy, but did not give up hope of Britain coming around to their way of thinking, as articulated in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deutsche Allgemeine Zeitung")]), _vm._v(":")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Brown House in Munich regards it a happy sign that precisely at this moment a small but energetic group has been formed in England which also preaches anti-Semitic Fascism and in the near future will certainly win a large following. Just as England has abandoned ‘free trade’ so she will abandon free racial theories for the principle of keeping the race pure.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In late April the press picked up on the establishment of the new "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ostgruppe")]), _vm._v(" headquarters, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Times")]), _vm._v(" reported a ‘Nazi Club in London’ but having made enquiries ‘in German circles’ they were assured there was no intention of establishing a ‘Brown House’ (like the Munich Party headquarters known "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Braunes Haus")]), _vm._v(") in London. The new club chairman "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ortsgruppenleiter")]), _vm._v(" Otto Bene was at pains to stress "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("‘the members had no desire to interfere with British politics’")]), _vm._v(" and pointed out ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("there were no British members’")]), _vm._v("."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Notes#rfnch01_7",
      "id": "fnch01_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With the heavy-footed diplomacy that rapidly became synonymous with the Nazis, Hitler despatched Rosenberg to London in May 1933 in an attempt to assure the British people the Nazis were no threat, to try to build bridges between the new regime and Great Britain and assess how the ascent of Nazism was being received in Britain itself. Rosenberg, who had unsurprisingly won no affection among the British on his last visit, had recently been appointed leader of the Nazi Party’s foreign political office. On 10 May 25,000 ‘un-German’ books by Jewish, Marxist, pacifist and other authors who did not meet with Nazi Party approval were burned in the square at the State Opera in Berlin. The books had been ‘collected’ from libraries and private collections by Nazi-led students of Berlin University and were publicly burned amid much flag waving, Nazi saluting, cheering and singing in the presence of Dr Goebbels, the Minister for Propaganda."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Notes#rfnch01_8",
      "id": "fnch01_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0005-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Reichsleiter")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Rosenberg laying the wreath on behalf of Hitler at The Cenotaph, 10 May 1933.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was also on 10 May that Rosenberg, as part of his visit to London but with no prior consultation with British authorities, formally laid a wreath on behalf of Hitler on The Cenotaph and gave a Nazi salute. As 11 May "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("dawned newspapers in Britain and around the world told the story of the Nazis burning books in Berlin and at 11am a car was spotted driving slowly along Whitehall. It slowed near the Cenotaph and a man was spotted grabbing the Nazi wreath, it was taken into the car which sped off. Returning to the Cenotaph a short while later First World War veteran, Captain James Sears (57), chairman of the Aylsham Branch of the British Legion in Norfolk and prospective Parliamentary candidate for South-West St Pancras, gave himself up to the police. The wreath was later recovered in a dishevelled state from the Thames.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Brought before Bow Street Magistrates on 11 May, Sears was clear about his reasons for his actions:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("… as a deliberate protest against the desecration of our national war memorial by the placing on it of a wreath by Hitler’s emissary, especially in view of the fact that the Hitler Government are contriving to do those things and foster those feelings which occurred in Germany before the war, for which so many of our fellows suffered and lost their lives.")]), _vm._v(" "), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Notes#rfnch01_9",
      "id": "fnch01_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sears appears to have received support among the general public for what he had done, but in the wake of a number of public protests, including demonstrators carrying banners emblazoned with ‘Down with Hitler’ outside Claridge’s where Rosenberg was staying, the court was mindful of maintaining order and could not dismiss the incident. The magistrate, with a stiff upper lip, pointed out, ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Whatever the defendant’s private opinions were, it was an improper and unmanly thing to do")]), _vm._v(",’ and handed down of a fine of forty shillings for wilful damage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("German authorities were furious, the Berlin "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tageblatt")]), _vm._v(" stated somewhat ominously ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A similar act would be punished more severely in Germany")]), _vm._v("’ and warned there would be diplomatic ramifications."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Notes#rfnch01_10",
      "id": "fnch01_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0006-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sir Horace Rumbold, The British Ambassador in Berlin, 1928–1933.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hitler was enraged and British Ambassador Sir Horace Rumbold was called to account for the way the wreath incident had been dealt with. Sir Horace informed him: ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("There had been an unmistakable swing in English "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("public opinion, based upon British concepts of freedom of the individual and consideration for other races.’")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Notes#rfnch01_11",
      "id": "fnch01_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was the most diplomatic way of telling Hitler that the behaviour and persecution policies of the Nazi Party were jarring with the British public. Rumbold had warned the British Government of the sinister actions of the Nazis as they rose to power but their response remained one of appeasement. Rumbold’s warnings went unheeded and having presented Hitler with such a reality check he was removed as British Ambassador in Berlin soon after. His replacement, Sir Eric Phipps, was also disquieted by what he saw and he was replaced in 1937 by Nevile Henderson, a man far more content to toe the appeasement line.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meanwhile, during the Rosenberg visit to London in 1933, the wax figure of Adolf Hitler at Madame Tussaud’s was doused in blood red paint and a placard hung around his neck proclaiming: ‘Hitler, the Mass Murderer’. A number of London bookshops, which attempted to capitalise on the publicity by displaying volumes featuring Hitler in their windows, had to send assistants out regularly with wet cloths and sponges to wipe spit from the plate glass.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A leader in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Spectator")]), _vm._v(" eloquently summed up the mood of Britain in the wake of the Rosenberg visit:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Herr Hitler’s unofficial foreign secretary has been in London this week sounding British opinion regarding Germany. He can have had little difficulty reaching a conclusion. Rarely has this nation been more nearly of one mind on anything than it has been in reprobation of the excesses that have marked the political upheaval which Adolf Hitler has inspired.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This led to further concern over the activities of the Nazi "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ostgruppe")]), _vm._v(" in Britain and questions were asked of Sir John Gilmour, the Home Secretary, in the House of Commons of whether a ‘Brown House’ was being established by Nazis in London. After an initial rebuttal to buy some time, when the Home Secretary was questioned again on the matter the following week his reply was that he declined to interfere with what were in effect private meetings. However, behind the scenes discussions had been held with MI6 with the conclusion being rather than banning the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ostgruppe")]), _vm._v(" and driving it underground, it was far better to keep it in the open so they could keep an eye on its activities. A member of Special Branch was charged with the duty of infiltrating the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ostgruppe")]), _vm._v(", attending its meetings and reporting back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The British national newspapers, notably the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daily Herald")]), _vm._v(", continued to run scare stories about the activities of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ostgruppe")]), _vm._v(", bringing the group a lot of unwelcome attention which resulted in them being evicted from the Park Gate Hotel. They moved to 27, Westbourne Terrace W2 in January 1934 "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("intending to keep a low profile, but the following month national newspapers were reporting ‘Nazi Stormtroopers in London’ accompanied by the story of how two Nazi Stormtroopers, the first to land in England in full uniform complete with Nazi arm bands, had arrived in Croydon airport. It turned out they had come under their own initiative after having been invited by a Mr Thomas, an English Fascist they had met in Germany, to come and stay in Stanhope Gardens S.W. Their arrival understandably drew quite some attention and via a translator they stated that they were on an eight-day visit during which they were hoping to make contact with British Fascists and others in sympathy with Hitler’s policies.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0008-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cleveland Terrace, Bayswater W2, where the Nazi Party had its London Headquarters between 1934 and 1939.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The report in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Times")]), _vm._v(" concluded: ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("After their arrival they were taken care of by responsible German people in London. They will be sent back to Germany immediately")]), _vm._v(".’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Notes#rfnch01_12",
      "id": "fnch01_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("More unwanted attention was brought on the Nazi HQ in London and they were ousted yet again. Finally, they managed to obtain rooms at 5, Cleveland Terrace (just around the corner from their original headquarters on Cleveland Square) where they remained until 1939.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8bc2ed8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Chapter01.vue
// module id = 78
// module chunks = 0